import { ReactNode } from 'react';
import { Route as ReactRouterRoute, RouteProps } from 'react-router-dom';
import { ErrorPage } from './error-page';
import ErrorBoundary from './error-boundary';

const Route = ({ children, ...props }: RouteProps) => {
  return (
    <ReactRouterRoute {...props}>
      {/*
        fallbackRender so the page that reports the crash knows what the crash was — the
        boundary already carried the error and nothing was reading it.

        `fallback` is kept alongside it rather than replaced. ErrorBoundary only calls
        fallbackRender `if (fallbackRender && error)`, and a thrown non-Error leaves that
        error falsy: `throw null`, a rejected promise carrying a string, anything from a
        library that does not throw Error instances. With fallbackRender alone those fell
        through to the boundary's own bare "Something went wrong." heading — on every route
        in the app, since this is what wraps all of them.
      */}
      <ErrorBoundary
        fallback={<ErrorPage />}
        fallbackRender={(error) => <ErrorPage error={error} />}
      >
        {children as ReactNode}
      </ErrorBoundary>
    </ReactRouterRoute>
  );
};

export { Route };
